<template>
    <div>
        <v-container>
            <v-card color="primary">
                <v-card-title>
                    <v-row justify="center">
                        <div class="info--text">ライセンスの申し込み</div>
                    </v-row>
                </v-card-title>
                <v-expansion-panels>
                    <v-expansion-panel
                    v-for="(application,index) in applications"
                    :key="index"
                    >
                    <v-expansion-panel-header>
                        <v-row align="center">
                            <v-col cols="3">カテゴリー： Travel Pro</v-col>
                            <v-col cols="3">{{application.email}}</v-col>
                        </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-card class="mx-1 my-3">
                            <v-card-title class="my-1">
                                Summary
                            </v-card-title>
                            <v-card-subtitle>
                                {{application.proLicenseSummary}}
                            </v-card-subtitle>
                        </v-card>
                        <v-card flat outlined v-for="(card,index) in application.proLicenseCards" :key="index" class="ma-1">
                            <v-container>
                                <v-row class="mx-5">
                                    <v-col class="px-5">
                                        <v-text-field
                                        v-model="card.title"
                                        label="施設名"
                                        readonly
                                        ></v-text-field>
                                        <v-textarea
                                        v-model="card.reasonOfRecom"
                                        label="おすすめの理由・魅力"
                                        outlined
                                        readonly
                                        ></v-textarea>
                                        <v-text-field
                                        v-model="card.url"
                                        label="URL"
                                        readonly
                                        ></v-text-field>
                                        <v-text-field
                                        v-model="card.googleMapUrl"
                                        label="googleマップURL"
                                        readonly
                                        ></v-text-field>
                                        <v-text-field
                                        v-model="card.access"
                                        label="アクセス（移動手段/所要時間）"
                                        readonly
                                        ></v-text-field>
                                        <v-text-field
                                        v-model="card.price"
                                        label="料金"
                                        readonly
                                        ></v-text-field>
                                        <v-text-field
                                        v-model="card.businessHour"
                                        label="営業時間"
                                        readonly
                                        ></v-text-field>
                                        <v-text-field
                                        v-model="card.hotelPlan"
                                        label="宿泊プラン(例：2食付き2名1室・禁煙)"
                                        readonly
                                        ></v-text-field>
                                        <v-text-field
                                        v-model="card.booking"
                                        label="予約/申込方法"
                                        readonly
                                        ></v-text-field>
                                        <v-text-field
                                        v-model="card.others"
                                        label="その他に条件指定されている項目について"
                                        readonly
                                        ></v-text-field>
                                        <v-text-field
                                        v-model="card.suppliInfo"
                                        label="補足情報・注意点など"
                                        readonly
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                            <!-- <v-card-actions>
                                <v-row justify="space-around">
                                    <v-btn large text class="green--text">Approve</v-btn>
                                    <v-btn large text class="red--text">Reject</v-btn>
                                </v-row>
                            </v-card-actions> -->
                        </v-card>
                    </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card>
        </v-container>
    </div>
</template>

<script>
/* eslint-disable no-console */
import {db} from '@/fb'
export default {
    name:'licenseApplications',
    data(){
        return{
            applications:[]
        }
    },
    methods:{
        convertDate(dateNow){
            var formatedDate = new Date(dateNow);
            return formatedDate
        }
    },
    created(){
        let ref = db.collection('travel_licenses').where('proLicense','==',{applied:true, received:false})
        ref.get()
        .then(snap=>{
            snap.forEach(doc=>{
                this.applications.push(doc.data())
            })
        })
        .catch(err=>{
            console.log(err)
        })
    }
}
</script>

<style>
    img {
        max-width: 780px !important;
    }
</style>